var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBtc1DIv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    fill: "none",
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-22.726 -22.739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m261.68 144.73c-1.14 65.651-55.263 118.07-121.03 116.95-65.661-1.187-118.02-55.325-116.88-120.98 1.1403-65.65 55.226-118.06 120.84-116.91 65.76 0.925 118.17 55.252 117.07 120.93z",
    fill: "#f7931a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.52 117.28c-1.358-14.55-13.765-19.446-29.593-21.038l0.151-20.145-12.252-0.1226-0.108 19.698c-3.242-0.0167-6.518-0.0255-9.735 0.0616l0.108-19.698-12.389-0.0907-0.151 20.145c-2.6224-0.0139-5.2475 0.1185-7.8699 0.1046l-16.877-0.1475-0.0849 13.026s9.1079-0.1 8.837 0.145c4.9685 0.092 6.5772 2.963 6.9475 5.355l-0.1233 22.943c0.3428 0.067 0.7572-0.029 1.2781 0.179-0.481-0.035-0.7573 0.029-1.2382-6e-3l-0.0185 32.064c-0.2518 1.588-1.2577 4.007-4.6374 4.022 0.1701 0.106-9.0097-0.106-9.0097-0.106l-2.4011 14.653 15.942 0.036c2.9652 0.08 5.8984 0.022 8.6989 0.177l-0.1111 20.318 12.251 0.123 0.152-20.145c3.446 0.115 6.695 0.166 9.798 0.215l-0.183 20.007 12.252 0.122 0.111-20.318c20.638-1.049 35.08-6.095 36.913-25.572 1.505-15.539-5.68-22.551-17.502-25.542 7.329-3.55 11.767-9.856 10.845-20.464zm-17.461 43.487c-0.055 15.204-26.137 13.32-34.381 13.22l0.1-26.983c8.391 0.103 34.314-2.166 34.281 13.763zm-5.437-38.201c-0.055 13.784-21.781 12.17-28.753 12.067l0.237-24.5c6.825 0.1 28.609-1.978 28.516 12.433z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.46 137v-36.01l-7.475 1.755v-6.37l10.985-4.875h5.135v45.5zm32.092 0.78c-3.033 0-5.741-0.737-8.125-2.21-2.383-1.473-4.268-3.488-5.655-6.045-1.386-2.557-2.08-5.46-2.08-8.71s0.694-6.132 2.08-8.645c1.387-2.557 3.272-4.55 5.655-5.98 2.384-1.473 5.092-2.21 8.125-2.21 2.427 0 4.55 0.455 6.37 1.365s3.294 2.188 4.42 3.835v-18.98h8.32v46.8h-7.41l-0.91-4.615c-1.04 1.43-2.426 2.687-4.16 3.77-1.69 1.083-3.9 1.625-6.63 1.625zm1.755-7.28c2.687 0 4.875-0.888 6.565-2.665 1.734-1.82 2.6-4.138 2.6-6.955s-0.866-5.113-2.6-6.89c-1.69-1.82-3.878-2.73-6.565-2.73-2.643 0-4.831 0.888-6.565 2.665-1.733 1.777-2.6 4.073-2.6 6.89s0.867 5.135 2.6 6.955c1.734 1.82 3.922 2.73 6.565 2.73z",
    fill: "url(#paint0_radial_3517_14104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.63 191v-45.5h8.32v45.5zm30.334 0-16.64-45.5h8.905l12.87 36.985 12.935-36.985h8.775l-16.64 45.5z",
    fill: "url(#paint1_radial_3517_14104)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3517_14104",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(61.5 0 0 65.117 165 115)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40045A",
    offset: 0.038622
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A21E7C",
    offset: 0.67708
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3517_14104",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(59.608 0 0 65.117 170 169)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40045A",
    offset: 0.038622
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A21E7C",
    offset: 0.67708
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtc1DIv);
export default __webpack_public_path__ + "static/media/btc_1d_iv.4eb0c5642079ef8f774b6a5adc22c984.svg";
export { ForwardRef as ReactComponent };